import { Box, List } from "@saleor/macaw-ui-next";

import { Shortcusts } from "../shortcuts";
import { MenuItem } from "./Item";
import { useMenuStructureContext } from "./MenuStructureContext";

export const Menu = () => {
  // 상단 가로 메뉴바와 같은 구조를 나눠 쓴다 (2026-09-17 KST 수정)
  const menuStructure = useMenuStructureContext();

  return (
    <Box
      padding={3}
      overflowY="auto"
      className="hide-scrollbar"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
    >
      <List as="ol" display="grid" gap={1} data-test-id="menu-list">
        {menuStructure.map(menuItem => (
          <MenuItem menuItem={menuItem} key={menuItem.id} />
        ))}
      </List>

      <Shortcusts />
    </Box>
  );
};
